import { addDays, format, isWeekend, parseISO } from "date-fns";

export const toISO = (d) => format(d, "yyyy-MM-dd");
export const fromISO = (iso) => parseISO(iso);
export const dayLabel = (iso) => format(fromISO(iso), "EEEE, M/d/yyyy");
export const shortLabel = (iso) => format(fromISO(iso), "EEE M/d");
export const shortDate = (iso) => format(fromISO(iso), "M/d/yyyy");

export function schoolDays(startISO, endISO) {
  if (!startISO) return [];
  const out = [];
  let d = fromISO(startISO);
  const end = endISO ? fromISO(endISO) : d;
  while (d <= end && out.length < 10) {
    if (!isWeekend(d)) out.push(toISO(d));
    d = addDays(d, 1);
  }
  return out;
}

export const newDay = (iso) => ({ id: `${iso}-${Math.random().toString(36).slice(2, 8)}`, date: iso, items: [] });

export function nextSchoolDay(iso) {
  let d = addDays(fromISO(iso), 1);
  while (isWeekend(d)) d = addDays(d, 1);
  return toISO(d);
}
